/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { type JSX, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type RouteComponentProps, withRouter } from 'react-router-dom';

import styled from 'styled-components';

import { Accordion } from '../../components';
import CardsAccordion from '../../components/CardsAccordion';
import { withAPIService } from '../../networking';
import { CARD_CATEGORIES } from '../../shared/cardConfig/constants';
import { withStore } from '../../store';
import { getShipToSubtitle } from '../../utils/hooksLib';

const CompanyCardWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const WrapperContainer = styled.div`
  width: 100%;
`;

const Subtitle = styled.p`
  font-size: 20px;
  padding-left: 30px;
  color: var(--grey-3);
`;

interface MultiShipToProps extends RouteComponentProps {
  store: any;
  cards?: any[];
  dispatch?: any;
  apiService?: any;
}

function Component(props: MultiShipToProps): JSX.Element {
  const { store, cards = [] } = props;

  const { common } = store;
  const { policyAccepted } = common;

  const { t } = useTranslation();

  let finalCardList: any[] = [];

  const [expandedAccordion, setExpandedAccordion] = useState<any>(0);

  const [cardList, setCardList] = useState<any[]>([]);

  useEffect(() => {
    filterCompanyPage();
  }, []);

  const filterCompanyPage = () => {
    finalCardList = cards.filter((card: any) => {
      if (policyAccepted) {
        return card.key !== 'privacyPolicy';
      }
      return cards;
    });

    setCardList(finalCardList);
  };

  const accordionCallback = (index: number) => {
    setExpandedAccordion(index);
  };

  const createCards = (cards: any[], index: number, props: any) => {
    const dynamicCards = cards
      .map(({ key, ...card }: any) => {
        const { Component } = card;

        return (
          (CARD_CATEGORIES.invoiceDelivery === key && index > 0) || (
            <Component {...card} {...props} index={index} key={key} />
          )
        );
      })
      .filter(Boolean);

    return dynamicCards;
  };

  return store.customer.shipTo.length > 1 ? (
    <>
      <Accordion
        data={store.customer.shipTo.map((shipTo: any, i: number) => ({
          title: `tabTitles.ship to`,
          count: i + 1,
          Subtitle: () => (
            <Subtitle>
              {getShipToSubtitle({
                shipToAddress: shipTo.address,
                store
              })}
            </Subtitle>
          ),
          body: createCards(cards, i, props)
        }))}
      />
    </>
  ) : (
    <>
      <WrapperContainer>
        {cardList.map(({ key, ...card }: any, index: number) => {
          const { Component } = card;

          const title = key === 'additionalAttachmentCard' ? t(`financial.${key}.title`) : t(`shipTo.${key}.title`);

          const cardProps = {
            title: key === 'additionalAttachmentCard' ? t(`financial.${key}.subtitle`) : t(`shipTo.${key}.subtitle`),
            image: '/food/onboarding/assets/Tooltip.svg'
          };

          return (
            <React.Fragment key={key}>
              {key === 'privacyPolicy' && policyAccepted ? null : (
                <CompanyCardWrapper>
                  <CardsAccordion
                    accordionCallback={accordionCallback}
                    isOpen={expandedAccordion === index}
                    cardTitle={title}
                    cardIndex={index}
                    cardProps={cardProps}
                  >
                    <Component {...props} {...card} index={0} />
                  </CardsAccordion>
                </CompanyCardWrapper>
              )}
            </React.Fragment>
          );
        })}
      </WrapperContainer>
    </>
  );
}

const connectRouter = withRouter(Component);
const connectAPI = withAPIService(connectRouter);
const MultiShipTo = withStore(connectAPI);

export default MultiShipTo;
